module.exports = __webpack_public_path__ + "static/media/PERMIT Shanghai.a183df72.png";